<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left:5px;">通知——查看详情</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div>
          <el-table 
            min-height="200"  max-height="1000" 
          border 
          v-loading="listLoading" 
          :data="tableData" 
          style="width: 100%"
          >
            <el-table-column  prop="created_at" label="时间" width = "250"/>
            <el-table-column  prop="admin_name" label="操作人" width = "100" />
            <el-table-column  prop="content" label="通知记录" width = "500" />
            <el-table-column  align="center" prop="images" label="图片"> 
              
              <template slot-scope="scope">
                <el-col class="closeImg">
                  <el-image 
                  v-for="item in scope.row.images" 
                  :key="item.url" 
                  :src="item.url"
                  style="width: 100px; height: 100px;margin-right:5px;"
                  :preview-src-list="photoShow(scope.row.images)" >
                 </el-image>
                </el-col>
              </template>

            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="logNotice"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/pagination/index";
import { personalCenterApi } from "@/api/personalCenter.js";
import {
    logNoticeApi,
} from "@/api/time_notice.js"
import '@/assets/css/global.css'
export default {
  components: { Pagination },
  data() {
      return {
          listQuery:{
            id:"",
            page:1,
            limit:10
          },
          total:0,
          tableData:[],
          listLoading:false,
      }
  },
  methods:{
    logNotice(){
      this.listLoading = true
      logNoticeApi(this.listQuery)
        .then(response =>{
            this.personalCenter();
            this.tableData = response.data.data.data;
            this.total = response.data.data.total;
            this.listLoading = false
        })
        .catch(error=>{
          this.listLoading = false
        })
    },
    photoShow(item){
        item.photoList = []
        for(let m of item){
          item.photoList.push(m.url);
        }
        return item.photoList;
    },
     personalCenter(){
        personalCenterApi()
          .then(response =>{
            let data = response.data.data;
            if(data.notice_level_3 != 0){
                data.number = data.number - data.notice_level_3;
            }
            this.$store.commit("getNotice",data);
          })
          .catch(error =>{
          })
      },
  },
  created() {
     let item = this.$route.query.id;
     this.listQuery.id = item;
     this.logNotice();
     
  },
}
</script>
<style >
</style>